/** Отправка картинки как файла: сервер и UI воспринимают тип как не-изображение → ссылка, не превью. */
export function messengerImageAsAttachmentFile(file: File): File {
  return new File([file], file.name, {
    type: 'application/octet-stream',
    lastModified: file.lastModified,
  });
}
